import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

export const AwsOidcComponents = InstallSpec({
  identity: ItemComponent({
    label: "OIDC federation",
    description:
      "Allows P0 to grant and revoke AWS access for OIDC-authenticated agents (e.g. CI/CD pipelines). Requires the AWS integration to be installed for the same account.",
    type: "string",
    maturity: "preview",
    schema: {
      accountId: Element({
        label: "AWS account ID",
        type: "dynamic",
        step: "new",
      }),
      awsPartition: Element({ label: "AWS partition", type: "hidden" }),
      // We take the OIDC provider URL and audience here and use them to generate AWS
      // CLI/Terraform instructions for registering the identity provider — rather than
      // requiring the customer to set it up beforehand. This is to make onboarding
      // easier; there isn't much configurability available in AWS anyways.
      oidcProviderUrl: Element({
        label: "OIDC provider URL",
        description:
          "Issuer URL of your OIDC provider (e.g. https://token.actions.githubusercontent.com)",
        type: "string",
        step: "new",
        validator: async (_id, field) => {
          try {
            new URL(field);
          } catch {
            return "OIDC provider URL must be a valid URL";
          }
        },
      }),
      audience: Element({
        label: "Audience",
        description:
          "The aud claim the identity will send to AWS when calling APIs",
        type: "string",
        step: "new",
      }),
    },
  }),
});
